import { mockDataForQuestion } from '../containers/CardData/CardDataTabs/QuestionComponent/mockDataConstant';
import _ from 'lodash';
export const giveArrayOnBasisOfCount = (count: number) => {
    let questionCount: any = [];
    for (let i = 0; i < count; i++) {
        questionCount.push(i);
    }
    return questionCount;
}
export const setQuestionData = (props: any, checkData: string) => {
    
    const { questionData = [], setAccordianState, accordianState = [], setFilterQuestionArray, isComingFromQuestionComponent = false, isTabOpened, setIsTabOpened, setProgressBarForQuestion, progressBar } = props;
    const filteredQuestionData = questionData.map((ele: any) => ele._id);
    if (checkData === 'both') {
        if (!isTabOpened) {
            let filterArray: any = [];
            questionData.map((val: any) => {
                const { questions = [] } = val;
                questions.map((val: any) => {
                    filterArray.push(val);
                })
            })
            if (!accordianState.length) {
                setAccordianState(filterArray);
            }
            else {
                accordianState.map((ele: any) => {
                    if (!filteredQuestionData.includes(ele._id)) {
                        setAccordianState([...accordianState, { ...ele }]);
                    }
                })
            }
            const { setAccordingTouchIndex } = props;
            let contentId = '';
            let content_Id = '';
            let newAccordianTouchState: any = [];
            const { accordianTouched = [] } = props;
            newAccordianTouchState = [...accordianTouched];
            let totalCount = 0;
            let completedQuestionCount = 0;
            let filterQuestionArray: any = []

            // const ques = mockDataForQuestion.responseObject.requestInfo.details.subjects[0].questions;
            let index = 0;
            questionData && questionData.map((questionArray: any) => {
                const { questions = [] } = questionArray;
                questions.map((question: any) => {
                    const {
                        contentRequestItemsId = {},
                        count = 0,
                        code
                    } = question;

                    totalCount = totalCount + count;
                    const questionDataForArray = giveArrayOnBasisOfCount(count);
                    questionDataForArray && questionDataForArray.map((val: any, questionIndex: number) => {
                        if (contentRequestItemsId) {
                            const { contents = [] } = contentRequestItemsId;
                            let indexOfQuestionUsed: any = [];
                            if (contents.length) {
                                contents && contents.map((contentData: any) => {
                                    const { content_id = null } = contentData;
                                    if (content_id) {
                                        const { content_id: { _id = '', contentId: contentIdQuestion = '', unresolvedFeedbackCount = 0 } = {}, sequenceNo = 0, status = {} } = contentData;
                                        if (sequenceNo === questionIndex + 1 && !indexOfQuestionUsed.includes(questionIndex + 1)) {
                                            const isJobCompleted = _.get(status, 'creator.isJobCompleted', false);
                                            contentId = contentIdQuestion;
                                            content_Id = _id;
                                            if (!isTabOpened) {
                                                const { questionContent = [] } = newAccordianTouchState[index];
                                                newAccordianTouchState[index] = {
                                                    accordianIndex: index,
                                                    questionContent: [
                                                        ...questionContent,
                                                        {
                                                            questionIndex: questionIndex + 1,
                                                            attachedQuestions: {
                                                                content_Id,
                                                                contentId,
                                                                isJobCompleted,
                                                                isTouched: true,
                                                                unresolvedFeedbackCount,
                                                                previousVersion: {}
                                                            }
                                                        }
                                                    ]
                                                }
                                                filterQuestionArray.push({ contentId, content_Id, contentSubTypeCode: Number(code) });

                                                content_Id = '';
                                                contentId = '';
                                                if (isJobCompleted) {
                                                    completedQuestionCount = completedQuestionCount + 1;
                                                }

                                                indexOfQuestionUsed.push(questionIndex + 1);
                                            }

                                        }
                                    }
                                })

                                if (!isComingFromQuestionComponent && !isTabOpened && !indexOfQuestionUsed.includes(questionIndex + 1)) {
                                    const { questionContent = [] } = newAccordianTouchState[index];
                                    newAccordianTouchState[index] = {
                                        accordianIndex: index,
                                        questionContent: [
                                            ...questionContent,
                                            {
                                                questionIndex: questionIndex + 1,
                                                attachedQuestions: {
                                                    content_Id,
                                                    contentId,
                                                    isJobCompleted: false,
                                                    isTouched: true,
                                                    unresolvedFeedbackCount: 0,
                                                    previousVersion: {}
                                                }
                                            }
                                        ]
                                    }
                                }
                            } else {
                                const { questionContent = [] } = newAccordianTouchState[index];
                                if (!isComingFromQuestionComponent && !isTabOpened) {
                                    newAccordianTouchState[index] = {
                                        accordianIndex: index,
                                        questionContent: [
                                            ...questionContent,
                                            {
                                                questionIndex: questionIndex + 1,
                                                attachedQuestions: {
                                                    content_Id,
                                                    contentId,
                                                    isJobCompleted: false,
                                                    isTouched: true,
                                                    unresolvedFeedbackCount: 0,
                                                    previousVersion: {}
                                                }
                                            }
                                        ]
                                    }
                                }

                            }
                        }
                        else {
                            const { questionContent = [] } = newAccordianTouchState[index];
                            if (!isComingFromQuestionComponent && !isTabOpened) {
                                newAccordianTouchState[index] = {
                                    accordianIndex: index,
                                    questionContent: [
                                        ...questionContent,
                                        {
                                            questionIndex: questionIndex + 1,
                                            attachedQuestions: {
                                                content_Id,
                                                contentId,
                                                isJobCompleted: false,
                                                isTouched: false,
                                                unresolvedFeedbackCount: 0,
                                                previousVersion: {}
                                            }
                                        }
                                    ]
                                }
                            }
                        }
                    })
                    index = index + 1
                })
            })

            setAccordingTouchIndex(newAccordianTouchState)
            setIsTabOpened({ booleanValue: true })
            setProgressBarForQuestion({ totalCount, count: completedQuestionCount });
            setFilterQuestionArray(filterQuestionArray);
        }

    }
    else {
        if (!isTabOpened) {
            const { setAccordingTouchIndex } = props;
            let filterArray: any = [];
            questionData.map((val: any) => {
                const { questions = [] } = val;
                questions.map((val: any) => {
                    filterArray.push(val);
                })
            })

            if (!accordianState.length) {
                setAccordianState(filterArray);
            }
            else {
                accordianState.map((ele: any) => {
                    if (!filteredQuestionData.includes(ele._id)) {
                        setAccordianState([...accordianState, { ...ele }]);
                    }
                })
            }
            let contentId = '';
            let content_Id = '';
            let newAccordianTouchState: any = [];
            const { accordianTouched = [] } = props;
            newAccordianTouchState = [...accordianTouched];
            let totalCount = 0;
            let completedQuestionCount = 0;
            let index = 0;
            let filterQuestionArray: any = [];
            questionData && questionData.map((questionArray: any) => {
                const { questions = [] } = questionArray;
                questions.map((question: any) => {
                    const {
                        contentRequestItemsId = {},
                        count = 0,
                        code = ''
                    } = question;
                    totalCount = totalCount + count;
                    const questionDataForArray = giveArrayOnBasisOfCount(count);
                    questionDataForArray && questionDataForArray.map((val: any, questionIndex: number) => {

                        if (contentRequestItemsId) {
                            const { contents = [] } = contentRequestItemsId;
                            let indexOfQuestionUsed: any = [];
                            if (contents.length) {
                                contents && contents.map((contentData: any) => {
                                    const { content_id = null } = contentData;
                                    if (content_id) {
                                        const { content_id: { _id = '', contentId: contentIdQuestion = '', unresolvedFeedbackCount = 0 } = {}, sequenceNo = 0, status = {} } = contentData;

                                        // for debuging purpose questionIndex is been replaced by 1 data is not there
                                        if (sequenceNo === questionIndex + 1 && !indexOfQuestionUsed.includes(questionIndex + 1)) {
                                            const isJobCompleted = _.get(status, 'creator.isJobCompleted', false);
                                            contentId = contentIdQuestion;
                                            content_Id = _id;
                                            if (!isTabOpened) {
                                                const { questionContent = [] } = newAccordianTouchState[index];

                                                newAccordianTouchState[index] = {
                                                    accordianIndex: index,
                                                    questionContent: [
                                                        ...questionContent,
                                                        {
                                                            questionIndex: questionIndex + 1,
                                                            attachedQuestions: {
                                                                content_Id,
                                                                contentId,
                                                                isJobCompleted,
                                                                isTouched: true,
                                                                unresolvedFeedbackCount,
                                                                previousVersion: {}
                                                            }
                                                        }
                                                    ]
                                                }
                                                filterQuestionArray.push({ contentId, content_Id, contentSubTypeCode: Number(code) });
                                                content_Id = '';
                                                contentId = '';
                                                if (isJobCompleted) {
                                                    completedQuestionCount = completedQuestionCount + 1;
                                                }

                                                indexOfQuestionUsed.push(questionIndex + 1);
                                            }

                                        }
                                    }
                                })

                                if (!isComingFromQuestionComponent && !isTabOpened && !indexOfQuestionUsed.includes(questionIndex + 1)) {
                                    const { questionContent = [] } = newAccordianTouchState[index];
                                    newAccordianTouchState[index] = {
                                        accordianIndex: index,
                                        questionContent: [
                                            ...questionContent,
                                            {
                                                questionIndex: questionIndex + 1,
                                                attachedQuestions: {
                                                    content_Id,
                                                    contentId,
                                                    isJobCompleted: false,
                                                    isTouched: true,
                                                    unresolvedFeedbackCount: 0,
                                                    previousVersion:{}
                                                }
                                            }
                                        ]
                                    }
                                }


                            } else {

                                const { questionContent = [] } = newAccordianTouchState[index];
                                if (!isComingFromQuestionComponent && !isTabOpened) {
                                    newAccordianTouchState[index] = {
                                        accordianIndex: index,
                                        questionContent: [
                                            ...questionContent,
                                            {
                                                questionIndex: questionIndex + 1,
                                                attachedQuestions: {
                                                    content_Id,
                                                    contentId,
                                                    isJobCompleted: false,
                                                    isTouched: true,
                                                    unresolvedFeedbackCount: 0,
                                                    previousVersion: {}
                                                }
                                            }
                                        ]
                                    }
                                }

                            }

                        }
                        else {
                            const { questionContent = [] } = newAccordianTouchState[index];
                            if (!isComingFromQuestionComponent && !isTabOpened) {
                                newAccordianTouchState[index] = {
                                    accordianIndex: index,
                                    questionContent: [
                                        ...questionContent,
                                        {
                                            questionIndex: questionIndex + 1,
                                            attachedQuestions: {
                                                content_Id,
                                                contentId,
                                                isJobCompleted: false,
                                                isTouched: false,
                                                unresolvedFeedbackCount: 0,
                                                previousVersion: {}
                                            }
                                        }
                                    ]
                                }
                            }
                        }
                    })
                    index = index + 1
                })
                setAccordingTouchIndex(newAccordianTouchState)
                setIsTabOpened({ booleanValue: true })
                setProgressBarForQuestion({ totalCount, count: completedQuestionCount });
                setFilterQuestionArray(filterQuestionArray);
            })

        }
    }
}